import React from 'react';

export const pageMeta = {
  "name": "JS Date Formats",
  "link": "/javascript/dates/formats"
};

export default function JavascriptDatesFormats() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">JS Date Formats</h2>
      <p>Route: /javascript/dates/formats</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
